import React from 'react';

/**
 * MetricCard - dashboard top-row tile.
 * Phase 9.
 *
 * @param {object}  props
 * @param {string}  props.label    - small header text.
 * @param {*}       props.value    - large primary value.
 * @param {number=} props.delta    - percent change (-1 to +1+ range), optional.
 * @param {string=} props.icon     - emoji or short string rendered top-right.
 * @param {string=} props.accent   - tailwind text color for the value.
 */
export default function MetricCard({ label, value, delta, icon, accent }) {
  const hasDelta = typeof delta === 'number' && Number.isFinite(delta);
  const positive = hasDelta && delta >= 0;
  const pct      = hasDelta ? (Math.abs(delta) * 100).toFixed(0) : null;

  return (
    <div className="relative card card-hover p-5 overflow-hidden group">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-10 -right-10 w-32 h-32 rounded-full
                   bg-teal-500/10 opacity-70 blur-2xl group-hover:opacity-100 transition"
      />
      <div className="relative flex items-start justify-between">
        <p className="text-xs font-semibold uppercase tracking-wider text-ink-faint">{label}</p>
        {icon && (
          <span className="text-base leading-none w-9 h-9 rounded-xl bg-teal-50 border border-teal-100 text-teal-700 flex items-center justify-center shadow-xs" aria-hidden>
            {icon}
          </span>
        )}
      </div>
      <p className={`relative font-heading text-3xl font-bold mt-2 tracking-tight ${accent || 'text-ink'}`}>{value}</p>
      {hasDelta && (
        <p className={`relative text-xs font-semibold mt-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full
                        ${positive ? 'text-teal-700 bg-teal-50 border border-teal-200/60' : 'text-rose-700 bg-rose-50 border border-rose-200/60'}`}>
          {positive ? '▲' : '▼'} {pct}% wow
        </p>
      )}
    </div>
  );
}
